export class LoanEndDateExpirationError extends Error {
  constructor (bookTitle, ...params) {
    super(...params)
    this.bookTitle = bookTitle
    this.ymlKey = (() => {
      if (bookTitle) return 'loan_end_date_expiration_with_booktitle_error'
      return 'loan_end_date_expiration_error'
    })()
  }
}



// WEBPACK FOOTER //
// ./src/lib/CustomErrors.js